import * as m from "@paraglide/messages"
import { useRouteShellContext } from "@components/routeShellContext"
import OptimizedImage from "../../OptimizedImage"
import "./styles.css"

export function Title() {
  const { locale } = useRouteShellContext()

  return (
    <a
      className="menu-logo"
      href={`/${locale}`}
      aria-label="Menu Logo"
    >
      <OptimizedImage
        src="/playbrain-word-logo-white.svg"
        alt={(m.common_playbrain({}, { locale: locale }) ?? "PLAYBRAIN").toUpperCase()}
        width={208}
        height={40}
      />
    </a>
  )
}

export default Title
